import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from 'react-admin';
import copyText from '@utils/copy';
import { Link } from '@material-ui/core';

import { ThunkGetPublicApiKey } from '@store/slices/publicApiKey/thunks';
import {
  PublicApiKeyLoadingSelector,
  PublicApiKeySelector,
} from '@store/slices/publicApiKey';
import CopyIcon from '@assets/icons/copy_blue.svg';

import KeyField from '@common/TableComponents/KeyField';
import ActionFieldItem from '@common/ActionButtons/ActionFieldItem';

import useStyles from './styles';

const PublicApiKeys = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const apiKey = useSelector(PublicApiKeySelector);
  const loading = useSelector(PublicApiKeyLoadingSelector);

  const onMount = useCallback(() => {
    dispatch(ThunkGetPublicApiKey());
  }, [dispatch]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  const getSwaggerLink = useCallback(() => `${apiKey.key}/swagger`, [apiKey]);

  if (loading) return <Loading />;

  return (
    <div className={classes.container}>
      <div className={classes.keyName}>
        Your personal key for public access to API
      </div>
      <div className={classes.keyField}>
        <KeyField record={apiKey} key="value" source="value" />
        <ActionFieldItem
          handler={() => copyText(apiKey.value)}
          toolTip="copy to clipboard"
        >
          <img src={CopyIcon} alt="copy to clipboard" />
        </ActionFieldItem>
      </div>
      <Link target="_blank" href={getSwaggerLink()}>
        Swagger documentation
      </Link>
    </div>
  );
};

export default PublicApiKeys;
